/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import Icon from "./Icon";

export default class ViewFixed extends BaseCom {
    render() {
        let style = this.props.style || {};
        return (
            <div id={this.props.id} view-data="fixed" className={'position-fixed' + (this.props.className ? ' ' + this.props.className : '')}
                style={{
                    ...style,
                    top: this.props.top || 'auto',
                    left: this.props.left || 'auto',
                    right: this.props.right || 'auto',
                    bottom: this.props.bottom || 'auto',
                    overflow: this.props.overflow || 'auto',
                    width: this.props.width || 'auto',
                    height: this.props.height || 'auto',
                    zIndex: this.props.zIndex || 1000
                }}>
                    {this.props.onClose && <div style={{position: 'absolute', right: '2rem', top: '0'}} onClick={this.props.onClose}><Icon icon="faClose" /></div>}
                {this.props.children}
            </div>
        )
    }
}